import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LandingPageComponent } from './landing-page/landing-page.component';
import { LoggedInGuard } from './auth/logged-in-guard.service';
import { HomeComponent } from './home/home.component';
import { SuperuserPermissionGuard } from './superuser/superuser-permission-guard.service';
import { SuperuserModule } from './superuser/superuser.module';

/**
 * Default route for application
 * @type {[{path: string; redirectTo: string; pathMatch: string}]}
 */
const routes: Routes = [
  {
    path: 'superuser',
    canActivate: [LoggedInGuard, SuperuserPermissionGuard],
    loadChildren: () => import('./superuser/superuser.module').then(mod => mod.SuperuserModule)
  },
  {path: '', redirectTo: '/home', pathMatch: 'full'},
  {path: 'map', redirectTo: '/home', pathMatch: 'full'},
  {
    path: 'home/:id?vivoId=true',
    component: HomeComponent,
    canActivate: [LoggedInGuard]
  },
  {
    path: 'landing',
    component: LandingPageComponent,
    canActivate: [LoggedInGuard]
  },
  {
    path: 'home',
    component: HomeComponent,
    canActivate: [LoggedInGuard]
  },
];

/**
 * App routes. Only initialization is done here, otherwise routing is done by feature routing modules.
 */
@NgModule({
  imports: [RouterModule.forRoot(routes, { relativeLinkResolution: 'legacy' }), SuperuserModule],
  exports: [RouterModule]
})
export class AppRoutingModule { }
